const ExamInfoBlock = props => {
  return (
    <div>
      Exam Info Here
    </div>
  );
}

export default ExamInfoBlock;